import React, { useState } from 'react';
import { Scissors, CheckCircle2, ArrowRight } from 'lucide-react';
export function CouponSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section id="coupon" className="py-20 px-4 bg-gradient-to-br from-sky-50 to-white relative overflow-hidden" data-id="element-17">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-sky-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2" data-id="element-18" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#b87333]/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 translate-y-1/2" data-id="element-19" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-21">
          {/* LEFT: Visual Coupon */}
          <div className="relative group" data-id="element-22">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#b87333] to-amber-400 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-23" />
            <div className="relative bg-white border-2 border-dashed border-[#b87333] rounded-2xl p-8 sm:p-10 shadow-xl overflow-hidden" data-id="element-24">
              <Scissors className="absolute top-4 right-4 w-6 h-6 text-[#b87333]/40 -rotate-90" data-id="element-25" />

              <div className="text-center space-y-4" data-id="element-26">
                <div className="inline-block bg-[#0c2340] text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider mb-2" data-id="element-27">
                  SPECIAL OFFER
                </div>
                <h3 className="text-5xl sm:text-6xl font-black text-[#b87333] tracking-tight" data-id="element-28">
                  $50 OFF
                </h3>
                <p className="text-xl sm:text-2xl font-bold text-[#0c2340]" data-id="element-29">
                  Your First Gutter Service
                </p>
                <div className="pt-6 pb-4" data-id="element-30">
                  <div className="bg-slate-50 border border-slate-200 rounded-lg py-3 px-6 inline-block" data-id="element-31">
                    <span className="text-slate-500 text-sm uppercase tracking-wider block mb-1" data-id="element-32">
                      Use Code
                    </span>
                    <span className="text-2xl font-mono font-bold text-slate-800 tracking-widest" data-id="element-33">
                      AFLOW50
                    </span>
                  </div>
                </div>
                <p className="text-sm text-slate-400" data-id="element-34">
                  Valid for new customers only. Expires 12/31/2025. Cannot be
                  combined with other offers.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT: Lead Capture Form */}
          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8 sm:p-10" data-id="element-35">
            {isSubmitted ? <div className="text-center py-12 space-y-4 animate-in fade-in zoom-in duration-500" data-id="element-36">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-37">
                  <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-38" />
                </div>
                <h3 className="text-3xl font-bold text-[#0c2340]" data-id="element-39">
                  Coupon Sent!
                </h3>
                <p className="text-lg text-slate-600" data-id="element-40">
                  Check your email for your $50 off coupon code. We look forward
                  to serving you!
                </p>
              </div> : <>
                <div className="mb-8" data-id="element-41">
                  <h3 className="text-3xl font-bold text-[#0c2340] mb-3" data-id="element-42">
                    Claim Your $50 Coupon
                  </h3>
                  <p className="text-slate-600 text-lg" data-id="element-43">
                    Enter your details below and we'll email your discount code
                    instantly.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5" data-id="element-44">
                  <div data-id="element-45">
                    <label htmlFor="coupon-name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-46">
                      Full Name
                    </label>
                    <input type="text" id="coupon-name" required className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="John Doe" data-id="element-47" />
                  </div>
                  <div data-id="element-48">
                    <label htmlFor="coupon-email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-49">
                      Email Address
                    </label>
                    <input type="email" id="coupon-email" required className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="john@example.com" data-id="element-50" />
                  </div>
                  <div data-id="element-51">
                    <label htmlFor="coupon-phone" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-52">
                      Phone Number (Optional)
                    </label>
                    <input type="tel" id="coupon-phone" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-slate-50 focus:bg-white" placeholder="(714) 555-0123" data-id="element-53" />
                  </div>

                  <button type="submit" className="w-full flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg shadow-[#b87333]/20 mt-4" data-id="element-54">
                    Send My Coupon
                    <ArrowRight className="w-5 h-5" data-id="element-55" />
                  </button>
                  <p className="text-xs text-center text-slate-400 mt-4" data-id="element-56">
                    By submitting this form, you agree to receive emails from
                    A-Flow. No spam, unsubscribe anytime.
                  </p>
                </form>
              </>}
          </div>
        </div>
      </div>
    </section>;
}